import React from 'react';
import {
  Navbar
} from 'react-bootstrap';
import {
  Link
} from 'react-router-dom';
import {
  routes
} from '../../../constants';
import logo from '../../../images/logo_rev.png';

const NoMatchNav = () => (
  <Navbar role='navigation' fluid={true}>
    <Navbar.Header>
      <Navbar.Toggle />
      <Navbar.Brand>
        <Link to={routes.app.dashboard}>
          <img src={logo} alt='Caddie' />
        </Link>
      </Navbar.Brand>
    </Navbar.Header>
  </Navbar>
);

export default NoMatchNav;



// WEBPACK FOOTER //
// ./src/containers/partials/nav/no-match-nav.js